import React from 'react'
// import * as Sentry from '@sentry/react'

const HelloWorld = () => {
  /*
  const handleClick = () => {
    try {
      throw new Error('error!')
    } catch (error) {
      console.error('### error', error)
      Sentry.captureException(error)
    }
  }

  //  throw new Error('error during rendering')
  */

  return <>{/* <button onClick={handleClick}>clickme</button> */}</>
}

export default HelloWorld
